// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js??ref--11-2!../../../../node_modules/sass-loader/lib/loader.js??ref--11-3!./SidebarStandard1.l.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("f23e1620", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/SidebarStandard1/SidebarStandard1.l.scss
// module id = 444
// module chunks = 55